import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-cream" data-id="element-20" data-mp="vtnxirotfgtu">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-21" data-mp="qu2xsf1tn4g2">
        <Reveal className="text-center" data-id="element-22" data-mp="qvw7k37qe4sa">
          <h2 id="bonos" className="font-display text-lg font-black uppercase leading-tight text-ink sm:text-2xl lg:text-3xl" data-id="element-23" data-mp="14t2jbdu1f380">
            🎁 5 Bonos incluidos
          </h2>
          <p className="mx-auto mt-1.5 max-w-2xl font-body text-[0.8rem] leading-snug text-slate sm:text-sm" data-id="element-24" data-mp="1ejnkn913ilum">
            Y para ayudarte a llevar lo aprendido mucho más allá, hoy también
            recibes estos 5 recursos complementarios sin costo adicional.
          </p>
        </Reveal>

        <ul className="mt-4 grid gap-2.5 md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="1jj9vjbtgbq09">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border-2 border-blush bg-white p-3.5" data-id="element-26" data-mp="3prddy7vc8xw1" data-mpi={i}>
              <h3 className="flex items-start gap-2 font-display text-[0.88rem] font-black uppercase leading-tight text-coral sm:text-[0.92rem]" data-id="element-27" data-mp="2k19n91wonl2">
                <GiftIcon size={15} className="mt-0.5 flex-shrink-0 text-gold" strokeWidth={2.5} data-id="element-28" data-mp="ck1w33v2njth" />
                🎁 {bono.title}
              </h3>
              {bono.subtitle && <p className="mt-1 text-[0.72rem] font-bold leading-snug text-ink sm:text-[0.76rem]" data-id="element-29" data-mp="lcnc4c7bjcem">
                  {bono.subtitle}
                </p>}
              <p className="mt-1.5 font-body text-[0.76rem] leading-snug text-slate sm:text-[0.8rem]" data-id="element-30" data-mp="vb2vtu40nje3">
                {bono.desc}
              </p>
              <p className="mt-1 font-script text-lg leading-tight text-coral" data-id="element-31" data-mp="1079xvbtakaqr">
                {bono.tag}
              </p>
              <div className="mt-auto flex items-center justify-between gap-2 border-t border-blush pt-2.5" data-id="element-32" data-mp="5me847m14szh">
                <span className="text-[0.72rem] text-slate line-through sm:text-[0.76rem]" data-id="element-33" data-mp="kbk4lnthg53o">
                  Valor: {bono.value}
                </span>
                <span className="rounded-full bg-coral px-2 py-0.5 text-[0.66rem] font-extrabold uppercase text-white sm:text-[0.7rem]" data-id="element-34" data-mp="fj0mqenrint2">
                  🔥 Hoy: Gratis
                </span>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.16} className="flex h-full flex-col items-center justify-center rounded-xl border-2 border-gold bg-ink p-3.5 text-center" data-id="element-35" data-mp="13afuwo27zzc8">
            <p className="font-display text-[0.82rem] font-black uppercase leading-tight text-gold sm:text-[0.9rem]" data-id="element-36" data-mp="350hl4i97ff2e">
              💰 Valor total de los 5 bonos:
            </p>
            <p className="mt-0.5 font-display text-3xl font-black text-white line-through decoration-coral decoration-2 sm:text-4xl" data-id="element-37" data-mp="1fkdy439vp73l">
              {BONUS_VALUE}
            </p>
            <p className="mt-1.5 text-[0.76rem] font-extrabold uppercase tracking-wide text-blush sm:text-[0.8rem]" data-id="element-38" data-mp="1kl1msiamxbun">
              Hoy te llevas los 5 bonos:
            </p>
            <p className="mt-0.5 font-display text-lg font-black uppercase text-coral sm:text-xl" data-id="element-39" data-mp="1arukx7f3sdzb">
              🎁 Gratis con tu compra
            </p>
          </Reveal>
        </ul>

        <Reveal delay={0.2} className="mt-4 flex justify-center" data-id="element-40" data-mp="10w0z0xfhv84v">
          <CtaButton size="lg" data-id="element-41" data-mp="mvq9bxpx7zla">
            ¡SÍ! QUIERO APRENDER COREANO DESDE CERO
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}